document.documentElement.classList.remove('no-js');

function initProductCarousel(carousel) {
  if (!carousel || carousel.dataset.carouselReady === 'true') return;

  const gallery = carousel.closest('.product-gallery');
  const slides = Array.from(carousel.querySelectorAll('[data-product-slide]'));
  const thumbnails = gallery ? Array.from(gallery.querySelectorAll('[data-carousel-thumbnail]')) : [];
  const previousButton = carousel.querySelector('[data-carousel-previous]');
  const nextButton = carousel.querySelector('[data-carousel-next]');
  const counter = carousel.querySelector('[data-carousel-current]');

  if (!slides.length) return;

  carousel.dataset.carouselReady = 'true';
  let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (activeIndex < 0) activeIndex = 0;

  const showSlide = (requestedIndex) => {
    activeIndex = (requestedIndex + slides.length) % slides.length;

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.hidden = !isActive;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

      if (!isActive) {
        slide.querySelectorAll('video').forEach((video) => video.pause());
      }
    });

    thumbnails.forEach((thumbnail, index) => {
      const isActive = index === activeIndex;
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    if (counter) counter.textContent = String(activeIndex + 1);
  };

  carousel.selectMedia = (mediaId) => {
    const targetIndex = slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
    if (targetIndex >= 0) showSlide(targetIndex);
  };

  if (previousButton) previousButton.addEventListener('click', () => showSlide(activeIndex - 1));
  if (nextButton) nextButton.addEventListener('click', () => showSlide(activeIndex + 1));

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => showSlide(Number(thumbnail.dataset.slideIndex)));
  });

  carousel.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showSlide(activeIndex - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      showSlide(activeIndex + 1);
    }
  });

  let touchStartX = 0;
  carousel.addEventListener('touchstart', (event) => {
    touchStartX = event.changedTouches[0].clientX;
  }, { passive: true });
  carousel.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) < 45) return;
    showSlide(distance > 0 ? activeIndex - 1 : activeIndex + 1);
  }, { passive: true });

  showSlide(activeIndex);
}

function initProductCarousels(root = document) {
  root.querySelectorAll('[data-product-carousel]').forEach(initProductCarousel);
}

initProductCarousels();

document.addEventListener('shopify:section:load', (event) => {
  initProductCarousels(event.target);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-mesh-option]');
  if (!button) return;

  const group = button.closest('[data-mesh-group]');
  group.querySelectorAll('[data-mesh-option]').forEach((item) => {
    item.classList.remove('active');
    item.setAttribute('aria-pressed', 'false');
  });
  button.classList.add('active');
  button.setAttribute('aria-pressed', 'true');

  const finder = button.closest('[data-mesh-finder]');
  if (!finder) return;
  const values = {};
  finder.querySelectorAll('[data-mesh-group]').forEach((item) => {
    const active = item.querySelector('[data-mesh-option].active');
    values[item.dataset.meshGroup] = active ? active.dataset.value : '';
  });
  const title = finder.querySelector('[data-finder-title]');
  const detail = finder.querySelector('[data-finder-detail]');
  if (title) title.textContent = 'Galvanized welded wire mesh';
  if (detail) detail.textContent = `${values.opening} opening · ${values.width} wide · ${values.length} roll`;
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;

  const option = select.options[select.selectedIndex];
  const section = select.closest('[data-product-section]');
  const form = section.querySelector('form.product-form__purchase');
  const available = option.dataset.available === 'true';

  const idInput = form ? form.querySelector('input[name="id"]') : null;
  if (idInput) idInput.value = option.value;

  const addButton = form ? form.querySelector('[data-add-to-cart]') : null;
  if (addButton) {
    addButton.disabled = !available;
    addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;
  }

  const price = section.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;

  const comparePrice = section.querySelector('[data-product-compare-price]');
  if (comparePrice) {
    comparePrice.textContent = option.dataset.comparePrice || '';
    comparePrice.hidden = !option.dataset.comparePrice;
  }

  const skuWrap = section.querySelector('[data-product-sku-wrap]');
  const sku = section.querySelector('[data-product-sku]');
  if (skuWrap && sku) {
    sku.textContent = option.dataset.sku || '';
    skuWrap.hidden = !option.dataset.sku;
  }

  const inventory = section.querySelector('[data-product-inventory]');
  const inventoryText = section.querySelector('[data-product-inventory-text]');
  if (inventory && inventoryText) {
    const quantity = Number(option.dataset.inventory || 0);
    const threshold = Number(inventory.dataset.lowStockThreshold || 0);
    const isManaged = option.dataset.inventoryManaged === 'true';
    let message = inventory.dataset.inStockText;

    if (!available) {
      message = inventory.dataset.outOfStockText;
    } else if (isManaged && quantity > 0 && quantity <= threshold) {
      message = inventory.dataset.lowStockText.replace('[quantity]', String(quantity));
    }

    inventoryText.textContent = message;
    inventory.classList.toggle('is-available', available);
    inventory.classList.toggle('is-unavailable', !available);
  }

  if (option.dataset.featuredMediaId) {
    const carousel = section.querySelector('[data-product-carousel]');
    if (carousel && typeof carousel.selectMedia === 'function') {
      carousel.selectMedia(option.dataset.featuredMediaId);
    }
  }

  if (window.history && window.history.replaceState) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url.toString());
  }
});
